export const SHORT_FIELD_LENGTH = 256;
export const LONG_FIELD_LENGTH = 65000;
export const CUSTOM_ATTRIBUTE_TEXT_FIELD_LENGTH = 1000;
export const MULTI_DROPDOWN_ONE_ITEM = 1;
export const DEFAULT_TEXT_FIELD_ROWS = 5;
